// extracted by mini-css-extract-plugin
module.exports = {"action":"UsersTable_action__2-4S2"};